var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconScience48Line = function SvgIconScience48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.52 30.4-6.82-9.93V12.7H32V9.3H16v3.4h2.3v7.77l-6.82 9.93a5.29 5.29 0 0 0 4.36 8.3h16.32a5.29 5.29 0 0 0 4.36-8.3Zm-2.68 3.88a1.88 1.88 0 0 1-1.68 1H15.84a1.9 1.9 0 0 1-1.56-3L21.4 22a1.65 1.65 0 0 0 .3-1v-8.3h4.6V21c-.01.357.095.708.3 1l7.12 10.36a1.871 1.871 0 0 1 .12 1.92Z",
    fill: "current"
  })));
};
export default SvgIconScience48Line;